import { IBasketBulkActionTypes } from '@epicuro-next/data/baskets';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

export const basketBulkActionIconsMap = {
  [IBasketBulkActionTypes.DELETE_BASKET]: faTrash,
};
